/* Product purchase behavior isolated from page content; offers are resolved from Shopify by grova-offers.js. */
(() => {
  if (window.grovaProductInformationLoaded) return;
  window.grovaProductInformationLoaded = true;
  function initializeProduct(root) {
    if (!root || root.hasAttribute("data-gold-drawer-section") || root.dataset.initialized === "true") return;
    root.dataset.initialized = "true";
    const controller = new AbortController();
    const { signal } = controller;
    let modalTrigger = null;
    root.grovaCleanup = () => {
      controller.abort();
      delete root.dataset.initialized;
    };
    const currency =
      root.dataset.currency || window.Shopify?.currency?.active || "EUR";
    const offers = window.GrovaOffers;
    const config = offers.read(root);
    const money = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency,
        minimumFractionDigits: Number(cents) % 100 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
      }).format(cents / 100);
    const state = { tier: 3, gallery: 0, subscribed: true, busy: false };
    const tiers = {};
    config.primary.forEach((option) => {
      const word = option.key === "1" ? "One" : "Three";
      const months = Number(option.key);
      tiers[months] = {
        ...option,
        id: option.variantId,
        months,
        compare: option.compareAt,
        sub: option.subscriptionPrice,
        renewal: option.renewalPrice,
        displaySub: option.subscriptionPrice,
        oneCompare: option.compareAt,
        one: option.price,
        delivery: `Renews At ${money(option.renewalPrice)} Every ${months === 1 ? "Month" : `${months} Months`}`,
        heroAlt: `Grova mushroom gummies ${months * 30}-day supply`,
        heroImage: root.dataset[`tier${word}Image`],
        heroThumb: root.dataset[`tier${word}Thumb`],
      };
    });
    root.querySelectorAll("[data-tier]").forEach((button) => {
      button.disabled = !offers.canBuy(config, tiers[button.dataset.tier]);
    });
    if (!offers.canBuy(config, tiers[state.tier]) && offers.canBuy(config, tiers[1])) state.tier = 1;
    const galleryTrack = root.querySelector("[data-gallery-track]");
    const galleryViewport = root.querySelector(".gnp-gallery__viewport");
    const galleryImages = [...root.querySelectorAll("[data-gallery-image]")];
    const loopGallery = !!root.querySelector('[data-gallery-loop]') && galleryImages.length > 1;
    const galleryIndex = (index) => loopGallery
      ? (index + galleryImages.length) % galleryImages.length
      : Math.max(0, Math.min(index, galleryImages.length - 1));
    function prepareGalleryImages() {
      // Request the current and neighbouring slides before a swipe exposes them.
      // Leave distant slides lazy and preserve the hero's high fetch priority.
      [state.gallery, state.gallery + 1, state.gallery - 1].forEach((index) => {
        const slide = galleryImages[galleryIndex(index)];
        if (!slide) return;
        const images = slide.matches('img') ? [slide] : [...slide.querySelectorAll('img')];
        images.forEach((image) => {
          if (image.getAttribute('fetchpriority') !== 'high') {
            image.setAttribute('fetchpriority', galleryIndex(index) === state.gallery ? 'auto' : 'low');
          }
          image.setAttribute('loading', 'eager');
        });
      });
    }
    const galleryThumbs = [...root.querySelectorAll("[data-gallery-thumb]")];
    const galleryThumbStrip = root.querySelector(".gnp-gallery__thumbs");
    const primaryGalleryImage = root.querySelector("[data-gallery-primary]");
    const primaryGalleryThumb = root.querySelector(
      "[data-gallery-primary-thumb]",
    );
    const galleryOfferData = root.querySelector('[data-gallery-offers]');
    const galleryOffers = galleryOfferData ? JSON.parse(galleryOfferData.textContent) : null;
    const resizedShopifyImage = (url, width) => {
      const imageUrl = new URL(url, window.location.href);
      imageUrl.searchParams.set('width', width);
      return imageUrl.href;
    };
    const responsiveShopifyImage = (url) =>
      [480, 720, 960, 1200, 1600]
        .map((width) => `${resizedShopifyImage(url, width)} ${width}w`)
        .join(", ");
    function galleryTransform(drag = 0) {
      const gap = galleryTrack ? parseFloat(window.getComputedStyle(galleryTrack).columnGap) || 0 : 0;
      return `translate3d(calc(-${state.gallery * 100}% - ${state.gallery * gap}px + ${drag}px),0,0)`;
    }
    function updateGalleryControls() {
      const previous = root.querySelector('[data-gallery-prev]');
      const next = root.querySelector('[data-gallery-next]');
      if (previous) previous.disabled = !loopGallery && state.gallery === 0;
      if (next) next.disabled = !loopGallery && state.gallery === galleryImages.length - 1;
      galleryImages.forEach((image, i) =>
        image.classList.toggle("is-active", i === state.gallery),
      );
      galleryThumbs.forEach((button, i) =>
        button.classList.toggle("is-active", i === state.gallery),
      );
    }
    function updateGallery(index, animate = true) {
      if (!galleryImages.length) return;
      state.gallery = galleryIndex(index);
      prepareGalleryImages();
      if (galleryTrack) {
        galleryTrack.style.transition = animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? "transform .42s cubic-bezier(.22,.61,.36,1)"
          : "none";
        galleryTrack.style.transform = galleryTransform();
      }
      updateGalleryControls();
      const activeThumb = galleryThumbs[state.gallery];
      if (galleryThumbStrip && activeThumb && galleryThumbStrip.clientWidth > 0) {
        const strip = galleryThumbStrip.getBoundingClientRect();
        const thumb = activeThumb.getBoundingClientRect();
        const left = strip.left + galleryThumbStrip.clientLeft;
        const right = left + galleryThumbStrip.clientWidth;
        const distance = thumb.left < left ? thumb.left - left : thumb.right > right ? thumb.right - right : 0;
        if (distance) {
          // Scroll only the thumbnail strip; keep the page at its current vertical position.
          galleryThumbStrip.scrollBy({
            left: distance,
            behavior: animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant',
          });
        }
      }
    }
    root
      .querySelectorAll("[data-gallery-thumb]")
      .forEach((button) =>
        button.addEventListener("click", () =>
          updateGallery(Number(button.dataset.galleryThumb)),
        ),
      );
    root
      .querySelector("[data-gallery-prev]")
      ?.addEventListener("click", () => updateGallery(state.gallery - 1));
    root
      .querySelector("[data-gallery-next]")
      ?.addEventListener("click", () => updateGallery(state.gallery + 1));
    // Native image dragging steals the pointer stream from the carousel.
    galleryViewport?.addEventListener("dragstart", (event) => event.preventDefault(), { signal });
    let pointerStartX = null;
    let pointerDeltaX = 0;
    galleryViewport?.addEventListener("pointerdown", (event) => {
      if (event.button !== 0 || event.isPrimary === false || event.target.closest("button, a, input, select, textarea")) return;
      pointerStartX = event.clientX;
      pointerDeltaX = 0;
      galleryViewport.classList.add("is-dragging");
      galleryViewport.setPointerCapture?.(event.pointerId);
    });
    galleryViewport?.addEventListener("pointermove", (event) => {
      if (pointerStartX === null) return;
      pointerDeltaX = event.clientX - pointerStartX;
      const beyondEdge = (state.gallery === 0 && pointerDeltaX > 0) ||
          (state.gallery === galleryImages.length - 1 && pointerDeltaX < 0);
      if (beyondEdge && !loopGallery) pointerDeltaX = 0;
      if (galleryTrack) {
        galleryTrack.style.transition = "none";
        // Keep the edge slide in view while tracking a gesture that will wrap.
        galleryTrack.style.transform = galleryTransform(beyondEdge ? 0 : pointerDeltaX);
      }
      if (Math.abs(pointerDeltaX) > 4) event.preventDefault();
    });
    const finishGalleryDrag = () => {
      if (pointerStartX === null) return;
      const distance = pointerDeltaX;
      pointerStartX = null;
      pointerDeltaX = 0;
      galleryViewport?.classList.remove("is-dragging");
      updateGallery(
        state.gallery + (Math.abs(distance) > 42 ? (distance < 0 ? 1 : -1) : 0),
      );
    };
    galleryViewport?.addEventListener("pointerup", finishGalleryDrag);
    const cancelGalleryDrag = () => {
      pointerDeltaX = 0;
      finishGalleryDrag();
    };
    galleryViewport?.addEventListener("pointercancel", cancelGalleryDrag);
    galleryViewport?.addEventListener("lostpointercapture", cancelGalleryDrag);
    // CSS already positions the first slide. Reset only stale inline positioning
    // from a previous editor initialization; do not measure layout during startup.
    if (galleryTrack?.style.transform) galleryTrack.style.removeProperty('transform');
    if (galleryTrack?.style.transition) galleryTrack.style.removeProperty('transition');
    updateGalleryControls();
    if (galleryViewport && window.IntersectionObserver) {
      const imageObserver = new IntersectionObserver((entries) => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        prepareGalleryImages();
        imageObserver.disconnect();
      }, { rootMargin: '200px' });
      imageObserver.observe(galleryViewport);
      signal.addEventListener('abort', () => imageObserver.disconnect(), { once: true });
    } else {
      prepareGalleryImages();
    }
    let heroRequest = 0;
    let heroInitialized = false;
    let heroAnimation = null;
    let heroGold = null;
    const heroContent = root.querySelector('[data-gallery-offer-content]') || primaryGalleryImage;
    signal.addEventListener('abort', () => {
      heroRequest++;
      heroAnimation?.cancel();
    });
    function updateHero(url, alt, thumb, gold) {
      if (!primaryGalleryImage || !url || (primaryGalleryImage.dataset.supplyImage === url && heroGold === gold)) return;
      const initial = !heroInitialized;
      heroInitialized = true;
      const request = ++heroRequest;
      primaryGalleryImage.dataset.supplyImage = url;
      heroGold = gold;
      heroAnimation?.cancel();
      const src = resizedShopifyImage(url, 1200);
      const srcset = responsiveShopifyImage(url);
      const applyImage = () => {
        root.querySelector('[data-gallery-offer-card]')?.classList.toggle('is-gold', gold);
        const banner = root.querySelector('[data-gallery-offer-banner]');
        if (banner) banner.hidden = !gold;
        const currentSources = (primaryGalleryImage.getAttribute('srcset') || '').split(',')
          .filter((candidate) => candidate.trim()).map((candidate) => {
            const [source, descriptor] = candidate.trim().split(/\s+/);
            return `${new URL(source, window.location.href).href} ${descriptor}`;
          }).join(', ');
        // Preserve the browser's initial responsive request when Liquid already supplied it.
        if (currentSources !== srcset) primaryGalleryImage.srcset = srcset;
        if (primaryGalleryImage.src !== src) primaryGalleryImage.src = src;
        primaryGalleryImage.alt = alt;
        if (primaryGalleryThumb) {
          primaryGalleryThumb.src = resizedShopifyImage(thumb || url, 160);
          primaryGalleryThumb.alt = '';
        }
      };
      if (!initial) updateGallery(0);
      if (initial || !heroContent.animate || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
        applyImage();
        return;
      }
      // Keep the current photograph and banner together while the selected offer loads.
      const nextImage = new Image();
      nextImage.sizes = primaryGalleryImage.sizes;
      nextImage.srcset = srcset;
      nextImage.src = src;
      const ready = nextImage.decode ? nextImage.decode() : new Promise((resolve, reject) => {
        if (nextImage.complete) return nextImage.naturalWidth ? resolve() : reject();
        nextImage.onload = resolve;
        nextImage.onerror = reject;
      });
      ready.then(async () => {
        if (request !== heroRequest || signal.aborted) return;
        heroAnimation = heroContent.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, fill: 'forwards' });
        await heroAnimation.finished;
        if (request !== heroRequest || signal.aborted) return;
        applyImage();
        heroAnimation.cancel();
        heroAnimation = heroContent.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' });
        await heroAnimation.finished;
        if (request === heroRequest) heroAnimation = null;
      }).catch(() => {
        // Cancellation is expected on rapid selection; failed images leave the current photo intact.
        if (request === heroRequest && !signal.aborted) delete primaryGalleryImage.dataset.supplyImage;
      });
    }
    function updateStickySelection() {
      const oneTimeLabel = root.querySelector('[data-one-time-label]');
      if (oneTimeLabel) oneTimeLabel.textContent = state.subscribed ? 'One Time Purchase' : 'One Time Purchase (Selected)';
      const selected = state.subscribed ? String(state.tier) : 'once';
      root.querySelectorAll('[data-sticky-option]').forEach((button) => {
        const key = button.dataset.stickyOption;
        const subscribed = key !== 'once';
        const tier = tiers[subscribed ? Number(key) : 1];
        button.disabled = state.busy || !offers.canBuy(config, tier, subscribed);
        button.setAttribute('aria-pressed', String(key === selected));
        if (!tier) return;
        const price = subscribed ? tier.sub : tier.one;
        button.querySelector('[data-sticky-option-price]').textContent = money(price);
        const compare = button.querySelector('[data-sticky-option-compare]');
        if (compare) {
          compare.textContent = money(tier.compare);
          compare.hidden = tier.compare <= price;
        }
        const gifts = button.querySelector('[data-sticky-gifts]');
        if (gifts) {
          let visibleGifts = 0;
          gifts.querySelectorAll('[data-sticky-gift]').forEach((gift) => {
            const key = gift.dataset.stickyGift;
            const configured = config.gifts[key];
            const eligible = subscribed && (tier.giftKeys || []).includes(key) && configured?.available && configured.price === 0 && !configured.requiresSellingPlan;
            gift.hidden = !eligible;
            if (eligible) visibleGifts += 1;
          });
          gifts.hidden = visibleGifts === 0;
        }
        const description = !subscribed ? '1 bag · No subscription' : key === '3'
          ? `3 bags · Then ${money(tier.renewal)} every 3 months`
          : `1 bag · ${money(tier.renewal)} every month`;
        button.querySelector('[data-sticky-option-description]').textContent = description;
        if (key === selected) {
          root.querySelector('[data-sticky-title]').textContent = button.querySelector('strong').textContent;
          root.querySelector('[data-sticky-caption]').textContent = !subscribed ? '1 bag · No subscription' : key === '3' ? `${money(price)}, then ${money(tier.renewal)} every 3 months` : `${money(tier.renewal)} every month`;
          root.querySelector('[data-sticky-supply]').textContent = key === '3' ? '90 Day Supply' : '30 Day Supply';
          const image = root.querySelector('[data-sticky-product-image]');
          if (image) {
            image.hidden = !tier.image;
            if (tier.image) image.setAttribute('src', tier.image);
            else image.removeAttribute('src');
          }
        }
      });
      const add = root.querySelector('[data-sticky-add]');
      if (add) {
        const tier = tiers[state.tier];
        const available = offers.canBuy(config, tier, state.subscribed);
        add.disabled = state.busy || !available;
        const label = state.busy ? 'Adding…' : !available ? 'Unavailable' : 'Add';
        const showPrice = available && !state.busy;
        const labelElement = add.querySelector('[data-sticky-add-label]');
        if (labelElement) {
          labelElement.textContent = label;
          const price = add.querySelector('[data-sticky-add-price]');
          price.textContent = showPrice ? money(state.subscribed ? tier.sub : tier.one) : '';
          price.hidden = !showPrice;
          add.querySelector('[data-sticky-add-separator]').hidden = !showPrice;
        } else {
          add.textContent = showPrice ? `${label} • ${money(state.subscribed ? tier.sub : tier.one)}` : label;
        }
      }
    }
    const offerGroup = root.querySelector('.grova-offers');
    let offerTransitionTimer;
    function cancelOfferTransition() {
      clearTimeout(offerTransitionTimer);
      if (!offerGroup?.classList.contains('is-switching')) return;
      offerGroup.classList.remove('is-switching');
      document.dispatchEvent(new CustomEvent('grova:layout-adjustment', { detail: { active: false } }));
    }
    function transitionPurchase() {
      if (!offerGroup || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        cancelOfferTransition();
        updatePurchase();
        return;
      }
      // Let the content regions resize naturally together. CSS transitions reverse
      // from their current position on rapid taps; no outer height is imposed.
      clearTimeout(offerTransitionTimer);
      offerGroup.classList.add('is-switching');
      document.dispatchEvent(new CustomEvent('grova:layout-adjustment', { detail: { active: true } }));
      updatePurchase();
      offerTransitionTimer = setTimeout(cancelOfferTransition, 360);
    }
    signal.addEventListener('abort', cancelOfferTransition);
    function updatePurchase() {
      updateStickySelection();
      const tier = tiers[state.tier];
      if (!tier || !tiers[1]) {
        root.querySelector('.gnp-add').disabled = true;
        root.querySelector('[data-mode="one-time"]').disabled = true;
        root.querySelector('[data-add-label]').textContent = 'Unavailable';
        return;
      }
      const galleryOffer = galleryOffers?.[state.tier === 3 ? 'bundle' : 'monthly'];
      const showGoldHero = state.subscribed && state.tier === 3;
      updateHero(galleryOffer?.url || tier.heroImage, galleryOffer?.alt || tier.heroAlt, galleryOffer?.url || tier.heroThumb, showGoldHero);
      root.querySelectorAll("[data-tier]").forEach((button) => {
        const active = state.subscribed && Number(button.dataset.tier) === state.tier;
        const card = button.closest('.grova-offer-card') || button;
        card.classList.toggle("is-active", active);
        button.setAttribute("aria-checked", active ? "true" : "false");
        const details = card.querySelector('.gnp-supply__details');
        if (details) {
          details.setAttribute('aria-hidden', active ? 'false' : 'true');
          details.toggleAttribute('inert', !active);
        }
        card.querySelectorAll('.grova-offer-card__reveal').forEach(region => {
          const visible = region.classList.contains('grova-offer-card__reveal--active') ? active : !active;
          region.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
        const daily = card.querySelector('[data-per-day]');
        const option = tiers[button.dataset.tier];
        if (daily && option) {
          const dailyPrice = new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
          }).format(Math.round(option.displaySub / (option.months * 30)) / 100);
          daily.textContent = `${dailyPrice} per day`;
          daily.hidden = !active;
        }
      });
      const subscriptionNote = root.querySelector('[data-subscription-note]');
      if (subscriptionNote) subscriptionNote.hidden = !state.subscribed;
      const deliveryCopy = root.querySelector('[data-delivery-copy]');
      if (deliveryCopy) deliveryCopy.textContent = `${state.tier === 3 ? `${money(tier.displaySub)} upfront, refills` : 'Refills'} ship every ${tier.months * 30} days at ${money(tier.renewal)} with free shipping.`;
      const refillCopy = root.querySelector('[data-subscription-refill-copy]');
      if (refillCopy) refillCopy.textContent = `Pay ${money(tier.displaySub)} for your first ${tier.months === 1 ? 'bag' : `${tier.months} bags`}, then ${money(tier.renewal)} every ${tier.months * 30} days.`;
      const guarantee = root.querySelector('[data-guarantee-label]');
      const guaranteeDays = 30;
      if (guarantee) guarantee.textContent = `${guaranteeDays} Day Money-Back Guarantee`;
      root.querySelectorAll('[data-guarantee-days]').forEach((element) => {
        element.textContent = String(guaranteeDays);
      });
      root.querySelectorAll("[data-compare-price]").forEach((element) => {
        element.textContent = money(tier.compare);
      });
      const subscriptionPrice = root.querySelector("[data-sub-price]");
      if (subscriptionPrice) subscriptionPrice.textContent = money(tier.sub);
      const oneTimeCompare = root.querySelector("[data-onetime-compare]");
      const oneTimeTier = tiers[1];
      oneTimeCompare.textContent = money(oneTimeTier.oneCompare);
      oneTimeCompare.hidden = oneTimeTier.oneCompare === oneTimeTier.one;
      root.querySelector("[data-onetime-price]").textContent = money(
        oneTimeTier.one,
      );
      root.querySelector("[data-add-price]").textContent = money(
        state.subscribed ? tier.displaySub : tier.one,
      );
      root.querySelector("[data-product-variant]").value = tier.id;
      root.querySelector("[data-selling-plan]").value =
        state.subscribed ? tier.sellingPlanId || "" : "";
      const legacyGifts = root.querySelector('[data-gifts]');
      if (legacyGifts) legacyGifts.hidden = !state.subscribed || state.tier !== 3;
      const addButton = root.querySelector(".gnp-add");
      const available = offers.canBuy(config, tier, state.subscribed);
      addButton.disabled = !available;
      root.querySelector("[data-add-label]").textContent = available ? "Add to Cart" : "Unavailable";
      root.querySelector('[data-mode="one-time"]').disabled = !offers.canBuy(config, tiers[1], false);
    }
    root.querySelectorAll("[data-tier]").forEach((button) =>
      button.addEventListener("click", () => {
        if (state.busy) return;
        if (state.subscribed && state.tier === Number(button.dataset.tier)) {
          updatePurchase();
          return;
        }
        state.subscribed = true;
        state.tier = Number(button.dataset.tier);
        transitionPurchase();
      }),
    );
    // Extend each native radio's hit area without intercepting the information buttons.
    root.querySelector('.grova-offers')?.addEventListener('click', (event) => {
      if (event.target.closest('button, a, input, select, textarea, summary, [role="button"]')) return;
      const choice = event.target.closest('.grova-offer-card')?.querySelector('[data-tier]');
      if (choice && !choice.disabled) choice.click();
    }, { signal });
    root.querySelector('.grova-offers')?.addEventListener('keydown', (event) => {
      if (!event.target.matches('[data-tier]') || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) return;
      event.preventDefault();
      const buttons = [...root.querySelectorAll('.grova-offers [data-tier]:not(:disabled)')];
      const direction = ['ArrowLeft', 'ArrowUp'].includes(event.key) ? -1 : 1;
      const next = buttons[(buttons.indexOf(event.target) + direction + buttons.length) % buttons.length];
      next?.focus({ preventScroll: true });
      next?.click();
    }, { signal });
    if (root.querySelector("[data-tier]")) updatePurchase();
    const productForm = root.querySelector(".gnp-product-form");
    const oneTimeButton = root.querySelector('[data-mode="one-time"]');
    function startInlineLoadingDots(element, label) {
      if (!element) return () => {};
      let dotCount = 1;
      element.textContent = `${label}.`;
      const interval = window.setInterval(() => {
        dotCount = dotCount === 3 ? 1 : dotCount + 1;
        element.textContent = `${label}${".".repeat(dotCount)}`;
      }, 320);
      return () => window.clearInterval(interval);
    }
    oneTimeButton?.addEventListener("click", async () => {
      const tier = tiers[1];
      if (state.busy || !offers.canBuy(config, tier, false) || oneTimeButton.disabled) return;
      state.busy = true;
      updateStickySelection();
      const originalMarkup = oneTimeButton.innerHTML;
      let failed = false;
      oneTimeButton.disabled = true;
      oneTimeButton.setAttribute("aria-busy", "true");
      const stopOneTimeLoading = startInlineLoadingDots(
        oneTimeButton,
        "Adding One Time Purchase",
      );
      try {
        const response = await fetch(
          `${window.Shopify?.routes?.root || "/"}cart/add.js`,
          {
            method: "POST",
            credentials: "same-origin",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              items: offers.items(config, tier, false),
            }),
          },
        );
        const item = await response.json();
        if (!response.ok)
          throw new Error(
            item.description || item.message || "Unable to add this item",
          );
        if (typeof window.openCartDrawer === "function") {
          await window.openCartDrawer();
        } else {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", { detail: { item } }),
          );
        }
      } catch (error) {
        console.error(error);
        failed = true;
        stopOneTimeLoading();
        oneTimeButton.textContent = "Please Try Again";
        window.setTimeout(() => {
          oneTimeButton.innerHTML = originalMarkup;
          updateStickySelection();
        }, 1800);
      } finally {
        stopOneTimeLoading();
        oneTimeButton.disabled = !offers.canBuy(config, tiers[1], false);
        oneTimeButton.removeAttribute("aria-busy");
        state.busy = false;
        if (!failed) oneTimeButton.innerHTML = originalMarkup;
        updateStickySelection();
      }
    });
    productForm?.addEventListener("submit", async (event) => {
      event.preventDefault();
      const addButton = productForm.querySelector(".gnp-add");
      const addLabel = productForm.querySelector("[data-add-label]");
      const addSeparator = productForm.querySelector("[data-add-separator]");
      const addPrice = productForm.querySelector("[data-add-price]");
      const originalLabel = addLabel?.innerHTML || "Add to Cart";
      let failed = false;
      const tier = tiers[state.tier];
      if (state.busy || addButton?.disabled || !offers.canBuy(config, tier, state.subscribed)) return;
      const subscribed = state.subscribed;
      state.busy = true;
      updateStickySelection();
      if (addButton) addButton.disabled = true;
      if (addSeparator) addSeparator.hidden = true;
      if (addPrice) addPrice.hidden = true;
      const stopAddLoading = startInlineLoadingDots(addLabel, "Adding");
      try {
        if (subscribed && tier.giftKeys.length) {
          const resetGiftPreferencesResponse = await fetch(
            `${window.Shopify?.routes?.root || "/"}cart/update.js`,
            {
              method: "POST",
              credentials: "same-origin",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                attributes: {
                  _grova_removed_subscription_gifts: "",
                  _grova_removed_subscription_gifts_version: "2",
                },
              }),
            },
          );
          if (!resetGiftPreferencesResponse.ok)
            throw new Error("Unable to reset free gift preferences");
        }
        const response = await fetch(
          `${window.Shopify?.routes?.root || "/"}cart/add.js`,
          {
            method: "POST",
            credentials: "same-origin",
            headers: { Accept: "application/json", "Content-Type": "application/json" },
            body: JSON.stringify({ items: offers.items(config, tier, subscribed) }),
          },
        );
        const item = await response.json();
        if (!response.ok)
          throw new Error(
            item.description || item.message || "Unable to add this item",
          );
        if (typeof window.openCartDrawer === "function") {
          await window.openCartDrawer();
          if (subscribed && tier.months === 3) {
            document.dispatchEvent(new CustomEvent("grova:gold-added"));
          }
        } else {
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", { detail: { item } }),
          );
        }
      } catch (error) {
        console.error(error);
        failed = true;
        stopAddLoading();
        if (addLabel) addLabel.textContent = "Please Try Again";
        const status = root.querySelector("[data-sticky-status]");
        if (status) status.textContent = error.message || "Unable to add. Please try again.";
        window.setTimeout(() => {
          if (addLabel) addLabel.innerHTML = originalLabel;
        }, 1800);
      } finally {
        stopAddLoading();
        state.busy = false;
        updateStickySelection();
        if (addButton) addButton.disabled = !offers.canBuy(config, tiers[state.tier], state.subscribed);
        if (addSeparator) addSeparator.hidden = false;
        if (addPrice) addPrice.hidden = false;
        if (addLabel && !failed) addLabel.innerHTML = originalLabel;
      }
    });
    const ingredientTabs = [...root.querySelectorAll("[data-ingredient-tab]")];
    const ingredientPanels = [
      ...root.querySelectorAll("[data-ingredient-panel]"),
    ];
    ingredientTabs.forEach((button) =>
      button.addEventListener("click", () => {
        const selected = button.dataset.ingredientTab;
        ingredientTabs.forEach((tab) => {
          const active = tab === button;
          tab.classList.toggle("is-active", active);
          tab.setAttribute("aria-selected", active ? "true" : "false");
        });
        ingredientPanels.forEach((panel) => {
          const active = panel.dataset.ingredientPanel === selected;
          panel.classList.toggle("is-active", active);
          panel.hidden = !active;
          if (!active) {
            panel.querySelectorAll("details").forEach((detail) => setIngredientOpen(detail, false, false));
          }
        });
      }, { signal }),
    );
    const ingredientDetails = [...root.querySelectorAll(".gnp-ingredients-panel details")];
    const ingredientAnimations = new Map();
    const setIngredientOpen = (detail, open, animate = true) => {
      const answer = detail.querySelector(".gnp-ingredient-answer");
      const height = detail.open && answer ? answer.getBoundingClientRect().height : 0;
      ingredientAnimations.get(detail)?.cancel();
      ingredientAnimations.delete(detail);
      detail.dataset.ingredientOpen = String(open);
      detail.querySelector("summary")?.setAttribute("aria-expanded", String(open));
      const marker = detail.querySelector(".gnp-ingredient-marker");
      if (marker) marker.textContent = open ? "−" : "+";
      if (!animate || !answer?.animate || window.matchMedia?.("(prefers-reduced-motion: reduce)").matches || (!detail.open && !open)) {
        detail.open = open;
        return;
      }
      detail.open = true;
      const animation = answer.animate(
        [{ height: `${height}px` }, { height: open ? `${answer.scrollHeight}px` : "0px" }],
        { duration: 280, easing: "cubic-bezier(.22, .61, .36, 1)", fill: "both" },
      );
      ingredientAnimations.set(detail, animation);
      animation.onfinish = () => {
        if (ingredientAnimations.get(detail) !== animation) return;
        detail.open = open;
        ingredientAnimations.delete(detail);
        animation.cancel();
      };
    };
    ingredientDetails.forEach((detail) => {
      setIngredientOpen(detail, detail.open, false);
      detail.querySelector("summary")?.addEventListener("click", (event) => {
        event.preventDefault();
        const open = detail.dataset.ingredientOpen !== "true";
        ingredientDetails.forEach((other) => {
          if (other !== detail && other.dataset.ingredientOpen === "true") setIngredientOpen(other, false);
        });
        setIngredientOpen(detail, open);
      }, { signal });
    });
    signal.addEventListener("abort", () => {
      ingredientDetails.forEach((detail) => setIngredientOpen(detail, detail.dataset.ingredientOpen === "true", false));
    }, { once: true });
    // Editor blocks are separate wrappers, but form one FAQ group per product.
    const productFAQs = [...root.querySelectorAll(".gnp-mini-accordions details")];
    const faqAnimations = new Map();
    const setFAQOpen = (detail, open, animate = true) => {
      const answer = detail.querySelector(".gnp-mini-accordion-answer");
      const currentAnimation = faqAnimations.get(detail);
      const height = detail.open && answer ? answer.getBoundingClientRect().height : 0;
      currentAnimation?.cancel();
      faqAnimations.delete(detail);
      detail.dataset.faqOpen = String(open);
      detail.querySelector("summary")?.setAttribute("aria-expanded", String(open));
      const marker = detail.querySelector("summary > span:last-child");
      if (marker) marker.textContent = open ? "−" : "+";
      const reducedMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
      if (!animate || !answer?.animate || reducedMotion || (!detail.open && !open)) {
        detail.open = open;
        return;
      }
      detail.open = true;
      const animation = answer.animate(
        [{ height: `${height}px` }, { height: open ? `${answer.scrollHeight}px` : "0px" }],
        { duration: 280, easing: "cubic-bezier(0.22, 0.61, 0.36, 1)", fill: "both" },
      );
      faqAnimations.set(detail, animation);
      animation.onfinish = () => {
        if (faqAnimations.get(detail) !== animation) return;
        detail.open = open;
        faqAnimations.delete(detail);
        animation.cancel();
      };
    };
    const closeProductFAQs = (except, animate = true) => {
      productFAQs.forEach((detail) => {
        if (detail !== except && detail.dataset.faqOpen !== "false") setFAQOpen(detail, false, animate);
      });
    };
    const initiallyOpenFAQ = productFAQs.find((detail) => detail.open);
    closeProductFAQs(initiallyOpenFAQ, false);
    productFAQs.forEach((detail) => {
      setFAQOpen(detail, detail.open, false);
      detail.querySelector("summary")?.addEventListener("click", (event) => {
        event.preventDefault();
        const open = detail.dataset.faqOpen !== "true";
        closeProductFAQs(detail);
        setFAQOpen(detail, open);
      }, { signal });
      detail.addEventListener("toggle", () => {
        if (faqAnimations.has(detail)) return;
        if (detail.open) closeProductFAQs(detail);
        setFAQOpen(detail, detail.open, false);
      }, { signal });
    });
    signal.addEventListener("abort", () => {
      faqAnimations.forEach((animation) => animation.cancel());
      faqAnimations.clear();
    }, { once: true });
    let touchY = 0;
    let releasePageScroll;
    const preventBackgroundScroll = (event) => {
      const openDialog = root.querySelector(
        ".gnp-modal:not([hidden]) .gnp-modal__dialog",
      );
      if (!openDialog) return;
      const y = event.touches?.[0]?.clientY;
      const delta = y === undefined ? event.deltaY : touchY - y;
      if (y !== undefined) touchY = y;
      if (!window.GrovaPageScroll.canScrollWithin(event.target, openDialog, delta) && event.cancelable) event.preventDefault();
    };
    document.addEventListener('touchstart', event => {
      touchY = event.touches[0]?.clientY || 0;
    }, { passive: true, capture: true, signal });
    document.addEventListener("wheel", preventBackgroundScroll, {
      passive: false,
      capture: true,
      signal,
    });
    document.addEventListener("touchmove", preventBackgroundScroll, {
      passive: false,
      capture: true,
      signal,
    });
    const lockPageScroll = () => {
      document.body.dataset.gnpScrollLocked = "true";
      releasePageScroll ||= window.GrovaPageScroll.lock(root);
    };
    const unlockPageScroll = () => {
      releasePageScroll?.();
      releasePageScroll = null;
      if (!document.querySelector('.gnp-modal:not([hidden])')) delete document.body.dataset.gnpScrollLocked;
    };
    signal.addEventListener('abort', () => {
      root.querySelectorAll('.gnp-modal').forEach(modal => { modal.hidden = true; });
      unlockPageScroll();
    }, { once: true });
    const modalCloseTimers = new Map();
    signal.addEventListener('abort', () => modalCloseTimers.forEach(clearTimeout), { once: true });
    const hideModal = (modal, restoreFocus = true) => {
      if (!modal) return;
      if (modal.classList.contains('is-closing')) return;
      const finish = () => {
        modalCloseTimers.delete(modal);
        modal.hidden = true;
        modal.classList.remove("is-opening", "is-open", "is-closing");
        if (!root.querySelector(".gnp-modal:not([hidden])")) {
          unlockPageScroll();
          if (restoreFocus) modalTrigger?.focus({ preventScroll: true });
        }
      };
      if (!restoreFocus || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
      } else {
        modal.classList.remove('is-opening');
        modal.classList.add('is-closing');
        const timing = getComputedStyle(modal).getPropertyValue('--grova-drawer-duration').trim();
        const duration = (parseFloat(timing) * (timing.endsWith('ms') ? 1 : 1000)) || 300;
        modalCloseTimers.set(modal, setTimeout(finish, duration));
      }
    };
    root.addEventListener("grova:nutrition-open", (event) => {
      const modal = event.target.closest(".gnp-modal");
      if (!modal) return;
      // Restore focus to the visible Ingredients opener, not its hidden inner link.
      event.detail.returnFocus = modalTrigger;
      // Focus moves straight into nutrition; do not scroll to the page trigger between drawers.
      hideModal(modal, false);
    }, { signal });
    const guaranteeModal = root.querySelector('[data-modal="guarantee"]');
    document.addEventListener('grova:product-modals-close', () => {
      root.querySelectorAll('.gnp-modal:not([hidden])').forEach(modal => hideModal(modal, false));
    }, { signal });
    const openFromButton = (button) => {
      const modal = root.querySelector(
        `[data-modal="${button.dataset.openModal}"]`,
      );
      if (modal) {
        document.dispatchEvent(new CustomEvent('grova:gold-drawer-close'));
        if (button.dataset.openModal === "nutrition") closeProductFAQs();
        root
          .querySelectorAll(".gnp-modal:not([hidden])")
          .forEach((openModal) => {
            if (openModal !== modal) {
              openModal.hidden = true;
              openModal.classList.remove("is-opening", "is-open");
            }
          });
        if (modal.matches(".gnp-ingredients-drawer, .grova-subscription-modal")) {
          modal.classList.remove("is-open");
          modal.classList.add("is-opening");
        }
        clearTimeout(modalCloseTimers.get(modal));
        modalCloseTimers.delete(modal);
        modal.classList.remove('is-closing');
        modalTrigger = button;
        modal.hidden = false;
        lockPageScroll();
        (modal.querySelector('.grova-subscription-modal__close') || modal.querySelector("[data-close-modal]"))?.focus({ preventScroll: true });
        if (modal.matches(".gnp-ingredients-drawer, .grova-subscription-modal")) {
          modal.querySelector(".gnp-modal__dialog")?.offsetHeight;
          requestAnimationFrame(() => modal.classList.remove("is-opening"));

        }
      }
    };
    document.addEventListener(
      "click",
      (event) => {
        const button = event.target.closest("[data-open-modal]");
        if (button?.closest(".grova-pdp") === root) openFromButton(button);
        else if (button?.matches('[data-guarantee-section-link]') && guaranteeModal &&
          document.querySelector('.grova-pdp--product[data-initialized="true"] [data-modal="guarantee"]') === guaranteeModal) {
          event.preventDefault();
          openFromButton(button);
        }
      },
      { signal },
    );
    root.querySelectorAll("[data-close-modal]").forEach((button) =>
      button.addEventListener("click", () => {
        hideModal(button.closest("[data-modal]"));
      }),
    );
    document.addEventListener(
      "keydown",
      (event) => {
        const modal = root.querySelector(".gnp-modal:not([hidden])");
        if (!modal) return;
        if (event.key === "Escape") {
          event.preventDefault();
          hideModal(modal);
        }
        if (event.key === "Tab") {
          const focusable = [
            ...modal.querySelectorAll(
              'button, a[href], input, select, textarea, [tabindex="0"], summary',
            ),
          ].filter((el) => !el.closest("[hidden]") && !el.disabled && el.tabIndex >= 0);
          const first = focusable[0],
            last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last?.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first?.focus();
          }
        }
      },
      { signal },
    );
    const stickyBuy = root.querySelector("[data-sticky-buy]");
    const stickyOptions = root.querySelector('[data-sticky-offers]');
    let releaseStickyAnchor = () => {};
    function preserveStickyPosition() {
      cancelOfferTransition();
      releaseStickyAnchor();
      const hero = root.querySelector('.gnp__hero');
      if (!hero || hero.getBoundingClientRect().bottom > 0) return () => {};
      const bottom = hero.getBoundingClientRect().bottom;
      const page = document.documentElement;
      const saved = [];
      const override = (element, property, value) => {
        saved.push([element, property, element.style.getPropertyValue(property), element.style.getPropertyPriority(property)]);
        element.style.setProperty(property, value, 'important');
      };
      document.dispatchEvent(new CustomEvent('grova:layout-adjustment', { detail: { active: true } }));
      override(page, 'overflow-anchor', 'none');
      override(page, 'scroll-behavior', 'auto');
      // These panels are off-screen. Settle their natural heights before paint
      // instead of chasing every animation frame with scroll corrections (iOS).
      const panels = [...hero.querySelectorAll('.gnp-supply__details, .grova-offer-card__reveal')];
      panels.forEach(panel => override(panel, 'transition', 'none'));
      let frame;
      let released = false;
      const release = () => {
        if (released) return;
        released = true;
        cancelAnimationFrame(frame);
        saved.forEach(([element, property, value, priority]) => {
          if (value) element.style.setProperty(property, value, priority);
          else element.style.removeProperty(property);
        });
        document.dispatchEvent(new CustomEvent('grova:layout-adjustment', { detail: { active: false } }));
        releaseStickyAnchor = () => {};
      };
      releaseStickyAnchor = release;
      return () => {
        // Flush each final grid state before restoring its transitions.
        panels.forEach(panel => panel.getBoundingClientRect());
        const delta = hero.getBoundingClientRect().bottom - bottom;
        if (Math.abs(delta) > 0.5) window.scrollBy({ top: delta, left: 0, behavior: 'instant' });
        frame = requestAnimationFrame(() => { frame = requestAnimationFrame(release); });
      };
    }
    signal.addEventListener('abort', () => releaseStickyAnchor());
    root.querySelectorAll('[data-sticky-option]').forEach((button) => {
      button.addEventListener('click', () => {
        if (state.busy || button.disabled) return;
        const settlePosition = preserveStickyPosition();
        state.subscribed = button.dataset.stickyOption !== 'once';
        state.tier = state.subscribed ? Number(button.dataset.stickyOption) : 1;
        updatePurchase();
        stickyOptions.open = false;
        stickyOptions.querySelector('summary').focus({ preventScroll: true });
        settlePosition();
      }, { signal });
    });
    root.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      const status = root.querySelector('[data-sticky-status]');
      if (status) status.textContent = '';
      productForm?.requestSubmit();
    }, { signal });
    document.addEventListener('click', (event) => {
      if (stickyOptions && !stickyOptions.contains(event.target)) stickyOptions.open = false;
    }, { signal });
    stickyOptions?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        stickyOptions.open = false;
        stickyOptions.querySelector('summary').focus({ preventScroll: true });
        event.stopPropagation();
      }
    }, { signal });
    const hero = root.querySelector(".gnp__hero");
    const storefrontFooterSections = [
      ...document.querySelectorAll(".shopify-section-group-footer-group"),
    ];
    const storefrontFooter =
      storefrontFooterSections[storefrontFooterSections.length - 1];
    const updateStickyBuy = () => {
      if (!stickyBuy || !hero) return;
      const viewport = window.visualViewport;
      const viewportBottom = viewport && viewport.scale === 1
        ? viewport.offsetTop + viewport.height
        : window.innerHeight;
      const heroBottom = hero.getBoundingClientRect().bottom;
      const footerReached =
        storefrontFooter &&
        storefrontFooter.getBoundingClientRect().top <= viewportBottom;
      const visible = heroBottom <= 0 && !footerReached;
      stickyBuy.classList.toggle("is-visible", visible);
      stickyBuy.inert = !visible;
      if (!visible && stickyOptions) stickyOptions.open = false;
    };
    root.querySelector("[data-scroll-buy]")?.addEventListener("click", () => {
      root
        .querySelector("[data-buy-panel]")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    root
      .querySelector("[data-scroll-reviews]")
      ?.addEventListener("click", () => {
        document
          .querySelector("#judgeme_product_reviews")
          ?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    window.addEventListener("scroll", updateStickyBuy, {
      passive: true,
      signal,
    });
    window.addEventListener("resize", updateStickyBuy, { signal });
    window.visualViewport?.addEventListener('resize', updateStickyBuy, { passive: true, signal });
    window.visualViewport?.addEventListener('scroll', updateStickyBuy, { passive: true, signal });
    updateStickyBuy();
    const hashOffers = new Map([
      ['#buy-two-get-one-free', { tier: 3, subscribed: true }],
      ['#monthly-subscription', { tier: 1, subscribed: true }],
      ['#one-time-purchase', { tier: 1, subscribed: false }],
    ]);
    const applyOfferHash = () => {
      const choice = hashOffers.get(window.location.hash);
      if (!choice || state.busy || !tiers[choice.tier]) return;
      // Select only: a deep link must never submit a purchase automatically.
      Object.assign(state, choice);
      updatePurchase();
    };
    window.addEventListener('hashchange', applyOfferHash, { signal });
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      const url = new URL(link.href, window.location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || (url.search && url.search !== location.search) || !hashOffers.has(url.hash)) return;
      event.preventDefault();
      if (state.busy) return;
      // Preserve preview/market query parameters and handle repeat clicks too.
      if (url.hash !== location.hash) history.pushState(null, '', url.hash);
      applyOfferHash();
      (root.querySelector('[data-buy-panel]') || productForm)?.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'start',
      });
    }, { signal });
    applyOfferHash();
    root.addEventListener("shopify:block:select", (event) => {
      const image = event.target.closest("[data-gallery-image]");
      if (image) updateGallery(Number(image.dataset.galleryImage));
      const details = event.target.querySelector("details");
      if (details) details.open = true;
    });
  }

  function initializeWithin(scope) {
    if (scope.matches?.(".grova-pdp--product")) initializeProduct(scope);
    scope.querySelectorAll(".grova-pdp--product").forEach(initializeProduct);
  }
  if (document.readyState === "loading")
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeWithin(document),
      { once: true },
    );
  else initializeWithin(document);
  document.addEventListener("shopify:section:load", (event) =>
    initializeWithin(event.target),
  );
  document.addEventListener("shopify:section:unload", (event) =>
    event.target
      .querySelectorAll(".grova-pdp--product")
      .forEach((root) => root.grovaCleanup?.()),
  );
})();
